import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Loading from '../../components/Common/Loading';
import getMessage from '../../utils/message';
import Step1 from '../../assets/images/dalite/step1.svg';
import Step2 from '../../assets/images/dalite/step2.svg';
import Step3 from '../../assets/images/dalite/step3.svg';
import Detect1 from '../../assets/images/dalite/detect1.svg';
import Detect1W from '../../assets/images/dalite/detect1w.svg';
import Detect2 from '../../assets/images/dalite/detect2.svg';
import Detect2W from '../../assets/images/dalite/detect2w.svg';
import Detect3 from '../../assets/images/dalite/detect3.svg';
import Checked from '../../assets/images/dalite/checked.svg';
import { actionAgreeCamera, actionApplyLater, actionImageQuanlity, actionMonitorTracking, actionTsoNewApplication, actionTsoOcrDa, actionTuHealthCheck } from '../../store/application/actions';
import { actionApplicationIP } from '../../store/common/actions';
import { detectMob, sw2Alert } from '../../utils/common';
import Error from '../../components/PopUpBox/Error';
import { PopUpBox } from '../../components';

const COUNT_TIMES = 4;

let delayTimer;
let delayTimeout;
let doc_ids = [];
let timeout_count = 0;
let custom_msg_count = 0;
const TIME_SCAN_MAX = 20; // seconds
const mode = 3;

function ApplicationIdCheckDalite() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [images, setImages] = useState(location.state?.current?.images ?? []);
    const [previews, setPreview] = useState(location.state?.current?.previews ?? []);
    const toast = useRef(null);
    const {
        handleSubmit,
        formState: { isSubmitting },
    } = useForm();
    const [countTimes, setCountTimes] = useState(location?.state?.count ?? COUNT_TIMES);
    const [step, setStep] = useState(location.state?.current?.step ?? 1);
    const [isVisibleInvalidToken, setIsVisibleInvalidToken] = useState(false);
    const [isDetectSuccess, setIsDetectSuccess] = useState(false)

    const rectangleContainerRef = useRef(null);
    const sdkRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    const [showNextStep, setShowNextStep] = useState(false);
    const [countDown, setCountDown] = useState(3);

    const [showPopup1, setShowPopup1] = useState(false);
    const [showPopup2, setShowPopup2] = useState(false);
    const [scanTimeoutCount, setScanTimeoutCount] = useState(0);

    const [isVisibleBlockCamera, setIsVisibleBlockCamera] = useState(false);
    const [isCameraBlock, setIsCameraBlock] = useState(false);
    const [showCustomMsg, setShowCustomMsg] = useState(false);

    const degreeCamera = useCallback(async () => {
        const response = await dispatch(
            actionAgreeCamera({
                agree_cam: false,
            }),
        );
        //setIsVisibleBlockCamera(true);
        if (response?.sts_code === 3) {
            // INVALID_TOKEN
            setIsVisibleInvalidToken(true);
        }
    }, [dispatch]);

    const agreeCamera = useCallback(async () => {
        const response = await dispatch(
            actionAgreeCamera({
                agree_cam: true,
            }),
        );
        if (response?.sts_code === 3) {
            // INVALID_TOKEN
            setIsVisibleInvalidToken(true);
        }
    }, [dispatch]);

    const onCheckGrantedCameraPermission = () => {
        navigator.permissions
            ?.query({ name: 'camera' })
            .then((permission) => {
                if (permission.state === 'prompt') {
                    setIsVisibleBlockCamera(true)
                }
                if (permission.state === 'granted') {
                    init();
                }
            })
            .catch(() => {
                degreeCamera();
            });
    }

    useEffect(() => {
        if (location.state?.count || location.state?.count === 0) {
            setCountTimes(location.state?.count);
        }
    }, [location.state?.count]);

    //hide overflow when the sdk is doing init
    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.style.height = '100vh';
        document.body.style.touchAction = 'none';
        onCheckGrantedCameraPermission();
        return () => {
            document.body.style.touchAction = 'auto';
            sdkRef?.current?.unmount();
        };
    }, []);

    // for getting the screen hight
    useEffect(() => {
        const handleResize = () => {
            setScreenHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const monitorTracking = async (status) => {
        const res = await dispatch(actionMonitorTracking({
            status: status,
            type: 1
        }));
        console.log('tracking cp', res);
    }

    //function - init sdk
    const init = async () => {
        try {
            setIsLoading(true);
            doc_ids = [];
            console.log("start init", location?.state?.cardType, doc_ids)
            
            const sdk = await new window.daLite({
                certiType: location?.state?.cardType === 2003 ? 1 : 2,
                rectangleContainer: rectangleContainerRef.current
            });

            /*
            -- version 2
            const sdk = await new window.daLite({
                hkPassType: location?.state?.cardType === 2003 ? 1 : 2,
                rectangleContainer: rectangleContainerRef.current,
                mode: mode
            });*/

            console.log(`w: ${rectangleContainerRef.current?.clientWidth}, h: ${rectangleContainerRef.current?.offsetHeight}`);

            sdkRef.current = sdk;
            // const { success, message, error } = await sdk.setup({ wasmPaths: "/wasms/"});
            const { success, message, error } = await sdk.setup();
            if (!success) {
                console.log(message)
                if (error?.name === 'NotAllowedError') {
                    console.log(error?.name);
                    await degreeCamera()
                    onBackLater()
                }
                return;
            }
            await agreeCamera();
            await sdk.addListeners(window.daLite.type.RESULT, [listener]);
            await sdk.addListeners(window?.daLite?.type?.NEXTSTEP, [onNextStep])
            //you might need to add the the "next step" listener for ui update

            await sdk.start();// start shooting 
            setTimeout(() => {
                if (document.getElementById('videoBackground') && document.getElementById('sdk_video')) {
                    document.getElementById('sdk_video').style.objectFit = 'cover';
                    document.getElementById('videoBackground').appendChild(document.getElementById('sdk_video'))
                }
                setIsLoading(false);
                onTimeout();
                monitorTracking('ID_SCAN');
            });
        } catch (ex) {
            console.error(ex);
            setIsLoading(false);
        }
    }

    const onTimeout = () => {
        let time = 0;
        timeout_count = 0;
        if (delayTimeout) {
            clearInterval(delayTimeout)
        }
        delayTimeout = setInterval(async () => {
            time++;
            if (time === TIME_SCAN_MAX) {
                console.log('scan timeout');
                clearInterval(delayTimeout);
                setScanTimeoutCount(scanTimeoutCount + 1);
                if (scanTimeoutCount === 0) {
                    console.log('show 1')
                    setShowPopup1(true);
                }
                if (scanTimeoutCount > 0) {
                    console.log('show 2')
                    setShowPopup2(true);
                    setShowPopup1(false);
                }
                timeout_count++;
            }
        }, 1000);
    }

    const onNextStep = (msg) => {
        console.log('next step: ', msg)
        setStep(msg.step > mode ? mode : msg.step);
        onTimeout();
    }

    const onReset = async () => {
        setImages([])
        setPreview([])
        setStep(1)
        doc_ids = [];
        await sdkRef.current.removeListeners(window.daLite.type.RESULT, [listener])
        await sdkRef.current.addListeners(window.daLite.type.RESULT, [listener]);
        await sdkRef.current.removeListeners(window.daLite.type.NEXTSTEP, [onNextStep])
        await sdkRef.current.addListeners(window.daLite.type.NEXTSTEP, [onNextStep]);
        await sdkRef.current.start();
    }

    const listener = useCallback(async (msg) => {
        const {
            code, preview, image,
        } = msg;
        console.log('app event ', msg);
        const custom_codes = ['NEEDFACE', 'NEEDROTATE', 'ERRORCERTI',
            'EXCEED_LEFT', 'EXCEED_TOP', 'EXCEED_RIGHT', 'EXCEED_BOTTOM'];
        let message = getMessage(code);
        if (custom_codes.includes(code)) {
            custom_msg_count += 1;
        } else {
            custom_msg_count = 0;
        }
        if (custom_msg_count > 4) {
            message = '請輕微搖晃手機以提高掃描偵測度';
            setShowCustomMsg(true)
            let countDown = 2;
            const loop = setInterval(() => {
                if (countDown > 0) {
                    countDown -= 1;
                } else {
                    clearInterval(loop);
                    setShowCustomMsg(false);
                    custom_msg_count = 0;
                }
            }, 1000);
        }

        if (timeout_count > 0 && code !== 'LOOSE') {
            console.log('timeout return');
            return;
        }

        if (delayTimer) {
            clearTimeout(delayTimer);
        }
        if (msg.step < mode + 1) {
            if (!toast.current) return;
            toast.current.style.display = 'block';
            delayTimer = setTimeout(() => {
                toast.current.style.display = 'none';
            }, 1000);
            if (code === 'LOOSE') {
                toast.current.style.background = '#0FEDA2';
                toast.current.textContent = message;
                console.log("restart after loose id")
                let countDown = 3;
                const loop = setInterval(() => {
                    if (countDown > 0) {
                        countDown -= 1;
                        if (!showNextStep) setShowNextStep(true);
                        setCountDown(countDown);
                    } else {
                        clearInterval(loop);
                        setCountDown(3);
                        setShowNextStep(false);
                        onReset()
                    }
                }, 1000);
            }
            if (code === 'OK') {
                toast.current.style.background = '#0FEDA2';
                toast.current.textContent = message;
            } else {
                toast.current.style.background = '';
                toast.current.textContent = message;
            }
        }
        if (image) {
            console.log("got image")
            setImages((pre) => [...pre, image]);
            setPreview(pre => [...pre, preview]);
            if (msg.step === mode) {
                setIsDetectSuccess(true);
                const video = document.getElementById('sdk_video')
                if (video) {
                    video?.pause();
                }
                // clear timeout
                if (delayTimeout) {
                    clearInterval(delayTimeout);
                }
            }
        }
    }, []);

    const getPlatformInfo = () => {
        let platformInfo = {
            device_type: '',
            browser_type: '',
            browser_version: '',
            os: ''
        };
        if (window.platform) {
            platformInfo.device_type = detectMob() ? 'Mobile' : 'PC';
            platformInfo.browser_type = window.platform.name;
            platformInfo.browser_version = window.platform.version;
            platformInfo.os = window.platform.os.family;
        }
        return JSON.stringify(platformInfo);
    }

    const getUtmParams = async () => {
        const responseIP = await dispatch(actionApplicationIP());
        let data = {};
        const utm_medium = sessionStorage.getItem('utm_medium');
        const utm_source = sessionStorage.getItem('utm_source');
        const utm_campaign = sessionStorage.getItem('utm_campaign');
        const utm_id = sessionStorage.getItem('utm_id');
        const utm_term = sessionStorage.getItem('utm_term');
        const utm_content = sessionStorage.getItem('utm_content');
        const session_id = localStorage.getItem('session_id');
        data = {
            session_id,
            utm_medium,
            utm_source,
            utm_campaign,
            utm_id,
            utm_term,
            utm_content,
            ip: responseIP?.ip ?? '',
            access_query: `utm_medium=${utm_medium ?? ''}&utm_source=${utm_source ?? ''}&utm_campaign=${utm_campaign ?? ''}&utm_id=${utm_id ?? ''}&utm_term=${utm_term ?? ''}&utm_content=${utm_content ?? ''}`,
        }
        return data;
    }

    // try apply request later
    async function apply(photo) {
        const utm_params = await getUtmParams();
        dispatch(actionApplyLater({
            utm_params,
            step: 'HKID',
            photo,
            lendela_id: location?.state?.lendela_id
        }));
        navigate('/application/confirm/complete', { replace: true, state: { status: true, completed: false, content: '' } });
    }

    const onImageQuanlity = async (image, step) => {
        setIsLoading(true)
        const response = await dispatch(
            actionImageQuanlity({
                photo: image,
                step
            }),
        );
        if (response?.sts_code === 3) {
            // INVALID_TOKEN
            setIsVisibleInvalidToken(true);
            return;
        }
        const success = response?.sts_code === 0; // TODO: for test
        setIsLoading(false);
        if (success) {
            console.log('received doc_ids: ', response?.content)
            doc_ids.push(response?.content);
            console.log('doc_ids', doc_ids);
        } else {
            navigate('/application-id-check-result', {
                replace: true,
                state: {
                    status: true,
                    result: success,
                    count: countTimes,
                    photo: image,
                    current: {},
                    lendela_id: location?.state?.lendela_id
                }
            });
        }
        return new Promise((resolve, reject) => {
            resolve(success);
        })
    }

    const handleImageCheck = async () => {
        console.log('---- start checking QC ----');
        setIsLoading(true)
        const result_qc1 = await onImageQuanlity(images[0], 1)
        if (!result_qc1) {
            return new Promise((resolve, reject) => {
                setIsLoading(false)
                resolve(false);
            });
        }
        const result_qc2 = await onImageQuanlity(images[1], 2)
        if (!result_qc2) {
            return new Promise((resolve, reject) => {
                setIsLoading(false)
                resolve(false);
            });
        }
        const result_qc3 = await onImageQuanlity(images[2], 3)
        if (!result_qc3) {
            return new Promise((resolve, reject) => {
                setIsLoading(false)
                resolve(false);
            });
        }
        return new Promise((resolve, reject) => {
            setIsLoading(false)
            resolve(true);
        });
    }

    const onFirstStepError = async () => {
        onTimeout();
        setShowPopup1(false);
    }

    const onBackLater = async () => {
        const img = images.length > 0 ? images[0] : null;
        setIsLoading(true)
        await tsoNewApplication();
        const status_tracking = (showPopup1 || showPopup2) ? 'TIMEOUT_SCAN' : 'EKYC_LATER'
        await monitorTracking(status_tracking)
        await apply(img);
        setIsLoading(false);
        //navigate('/application-id-check-result', { replace: true, state: { status: true, result: 99, count: 0 } });
    }


    const tsoNewApplication = useCallback(async () => {
        const responseIP = await dispatch(actionApplicationIP());
        const health_check_res = await dispatch(actionTuHealthCheck());
        console.log('health_check_res', health_check_res)
        const response = await dispatch(actionTsoNewApplication({ ip: responseIP?.ip }));
        if (response?.sts_code === 3) {
            // INVALID_TOKEN
            setIsVisibleInvalidToken(true);
        }
    }, [dispatch]);

    const onSubmit = async () => {
        setIsLoading(true)
        await tsoNewApplication()
        const result_qc = await handleImageCheck();
        if (!result_qc) {
            console.log('check QC images failed');
            return;
        }
        setIsLoading(true)
        const response = await dispatch(
            actionTsoOcrDa({
                photo: images[0],
                incline_front: images[1],
                vertical_back: images[2],
                version: location?.state?.cardType,
                application_io: getPlatformInfo(),
                flow: 1,
                vertical_front_id: doc_ids[0],
                incline_front_id: doc_ids[1],
                vertical_back_id: doc_ids[2],
            }),
        );
        if (response?.sts_code === 3) {
            // INVALID_TOKEN
            setIsVisibleInvalidToken(true);
            return;
        }
        if (response?.sts_code === 26) {
            // doc auth ocr error 
            apply(images[0]);
            return;
        }
        setIsLoading(false);
        navigate('/application-id-check-result', { replace: true, state: { status: true, result: response?.sts_code, count: countTimes, lendela_id: location?.state?.lendela_id } });
    };

    const getStepText = (next = 0) => {
        switch (step + next) {
            case 1:
                return '第一步：請掃描身份證的正面';
            case 2:
                return '第二步：請稍微向下傾斜身份證';
            case 3:
                return '第三步：請掃描身份證的背面';
            default:
                return '第一步：請掃描身份證的正面';
        }
    }
    

    return (
        <div className="fixed w-full z-50 top-0 left-1/2 bg-white" style={{ maxWidth: 487, transform: 'translateX(-50%)', height: screenHeight }}>
            <Loading isVisible={isSubmitting || isLoading} />
            {isVisibleBlockCamera && <PopUpBox.Error content={`請於稍後彈出的視窗允許取用相機權限 ${isCameraBlock ? '(blocked)' : ''}`} onClick={() => setIsVisibleBlockCamera(false)}>
                <div className="text-center my-3">
                    <button onClick={init} type="button" className="rounded-full text-white text-sm bg-lightningYellow px-14 py-2">
                        確定
                    </button>
                </div>
            </PopUpBox.Error>}
            {showNextStep && <Error>
                <div className="text-center">
                    <p className="text-gray1 my-6"> 檢測不到證件，請重新開始 <span className="text-primary2">({countDown}s)</span></p>
                </div>
            </Error>}
            {
                showPopup1 && <Error>
                    <div className="text-center">
                        <p className="text-gray1 mt-3">未能成功掃描身份證</p>
                        <button type='button' onClick={() => onFirstStepError()} className="rounded-full text-white text-xl px-12 mt-4 py-3 bg-primary">
                            繼續嘗試
                        </button>
                        <button type='button' onClick={onBackLater} className="rounded-full text-white text-xl px-12 my-4 py-3 bg-primary2">
                            稍後認證
                        </button>
                    </div>
                </Error>
            }
            {
                showPopup2 && <Error>
                    <div className="text-center">
                        <p className="text-gray1 mt-3">身份證驗證失敗</p>
                        <p className="text-gray1 mt-3 px-11 text-justify">未能成功完成身份證驗證。閣下的貸款申請資料已提交處理，我們的貸款專員稍後會聯絡閣下跟進。</p>
                        <button type='button' onClick={onBackLater} className="rounded-full text-white text-xl px-14 my-4 py-3 bg-primary">
                            確定
                        </button>
                    </div>
                </Error>
            }
            <div id="videoBackground" className="top-0 bg-transparent z-0 absolute" style={{ width: '100%', height: screenHeight }}></div>
            <div className="w-full flex flex-col justify-center z-[90] relative" style={{height: screenHeight}}>
                { 
                    <>
                    <div className="w-full flex items-center flex-col text-center absolute top-10">
                        <img src={step === 1 ? Step1 : (step === 2 ? Step2 : Step3)} className="w-3/5" />
                        <p className="text-lg rounded-lg py-3 px-6 bg-white bg-opacity-70 text-[#6C6B6F] text-center mt-6 font-semibold">{getStepText()}</p>
                    </div>
                        <div ref={rectangleContainerRef} className='relative flex items-center z-0 w-full h-[50vh]  p-2'>
                        <img id="img" src="vertical_front.png" style={{ display: 'none' }} />
                        <div id='rect1' style={{
                            background: (step === 1 || step === 3) ? `url(${Detect1W}) center no-repeat` : `url(${Detect2W}) center no-repeat`,
                        }} className='w-full h-[50vh] flex justify-center items-center relative'>
                            <img src={step === 1 ? Detect1 : (step === 2 ? Detect2 : Detect3)} />
                            {/* {showCustomMsg && <div className="absolute bg-gray2 rounded-lg w-full h-full flex justify-center items-center bg-opacity-70">
                                <p className="text-gray1 my-6"> 請輕微搖晃手機以提高掃描偵測度</p>
                            </div>} */}
                        </div>
                    </div>
                    <div className='w-full text-center px-5 absolute bottom-20'>
                        
                        {showCustomMsg ?
                            <p className={`px-5 py-2 text-white block rounded-lg bg-yellow-500`}>請輕微搖晃手機以提高掃描偵測度</p> :
                            <div ref={toast} className={`px-5 py-2 text-white rounded-lg bg-red-500`}>請提供香港身份證</div>   
                    }
                    </div>
                </>
                }
            </div>
            
            {previews.length > 0 && isDetectSuccess && <Preview onSubmit={onSubmit} images={previews} />}
        </div>
    );
}

function Preview({ images, onSubmit }) {
    return (
        <>
            <div className="p-10 fixed w-full z-[92] top-0 left-0 flex items-center justify-center h-full" style={{ backgroundColor: '#0000004d' }}>
                <div className="p-5 bg-white w-full rounded-md shadow-md" style={{ maxWidth: 414 }}>
                    <div className="text-center">
                        <p className="text-gray text-xl">身份證掃描成功</p>
                    </div>
                    <div className="flex space-x-4 mt-4 justify-center items-center">
                        {
                            images.map(pre => {
                                return (
                                    <div className="relative">
                                        <img src={pre} className="w-28 rounded-md" />
                                        <img src={Checked} className="absolute right-[-10px] bottom-[-10px]" />
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="text-center mt-5">
                        <button onClick={onSubmit}
                            type="submit"
                            className={`rounded-full text-white text-xl px-16 py-2 bg-primary`}>
                            確定
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ApplicationIdCheckDalite;